import {
    makeKey,
    update,
    handleApiResponseError,
    handleNetworkError
} from '../../../../utils/reducerOperations';
import {toast} from '../../../../utils/messageUtils';
export function fetchSurveyListFailed(state, payload) {
    let response = makeKey(
        'fetchSurveyApi',
        update(state.fetchSurveyApi, {
            ...(payload.response && payload.response.data
                ? handleApiResponseError(payload.response.data)
                : handleNetworkError(payload))
        })
    );
    toast.error(response.fetchSurveyApi.message);
    return response;
}
